module.exports = __webpack_public_path__ + "img/sv83on.8dd37a8f.svg";